import $ from 'jquery';
import './sdaSelect';
import './sdaSelectList';

/**  Creates a select type input on an empty div.
 * @param {Object} opts - {} - required.
 *     opts.list - [{}] - List of options for the select menu each property on the object will be attached to an
 *         html data attribute.
 *         opts.list[x].value -  - required value for $(this).val() functionality
 *         opts.mainTemplate  - hbs partial - template you want to use for the main select menu.
 *     opts.template - hbs partial - template you want to use for the items in the select menu.
 *     opts.selected - optional - object that you want to be selected at start.
 *     opts.iconPos  - position of the icon in the list;
 *
 *    #method .val() - returns the opts.list[x].value attribute for the selected item
 *
 *    ~event 'select' - emitted when any of the options in the list are clicked
 * @returns {Object} jQuery
 */
$.fn.sdaBasicSelect = function(opts = {}) {
    const that = this;
    const $mainTemplate = opts.mainTemplate;
    const iconPos = opts.iconPos || 'left';
    let $list;

    that.sdaSelect(opts);

    $list = that
        .find('.sda-select-list>ul')
        .children()
        .clone();

    that.html($mainTemplate())
        .find('.sda-select-list')
        .html($list)
        .sdaSelectList();

    $list.find('li').each(function(li) {
        $(li).addClass('icon-' + iconPos);
    });

    $list = that.find('.sda-select-list');
    that.on('select', function() {
        $list.close();
    });

    that.find('.sda-select-selected').on('click', function() {
        $list.toggleOpen();
    });

    return that;
};
